import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetAllAdvertisementsService = (screen: string) => {
  return HTTP_CLIENT.get(
    `${Endpoint.advertisement.getAdvertisement}/${screen}`
  );
};
const CreateAdvertisementService = (data: FormData) => {
  return HTTP_CLIENT.post(`${Endpoint.advertisement.addAdvertisement}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const DeleteAdvertisementService = (id: number) => {
  return HTTP_CLIENT.delete(
    `${Endpoint.advertisement.deleteAdvertisement}/${id}`
  );
};

const UpdateAdvertisementService = (id: number, data: FormData) => {
  return HTTP_CLIENT.patch(
    `${Endpoint.advertisement.updateAdvertisement}/${id}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export {
  GetAllAdvertisementsService,
  CreateAdvertisementService,
  DeleteAdvertisementService,
  UpdateAdvertisementService,
};
